/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export abstract class BaseOnePageFormModel extends BaseFormModel {

        protected internalSetupForm() {
            if (this.formConfiguration.mySteps.length > 0) {
                this.currentStepIndex = 0;
                this.currentStep = this.formConfiguration.mySteps[0];

                if (this.currentStep.formSections) {
                    this.currentStep.formSections.forEach(fs => {
                        this.formSectionService.splitFields(fs);
                    });
                }
                //this.loadStepUrls();
            } else {
                if (this.isConfigureMode) {
                    let newStep = this.formService.createFormStep(this.formConfiguration);
                    newStep.position = this.formConfiguration.mySteps.length;
                    newStep.objectSchema = this.dataSourceService.createNewObjectSchema();
                    newStep.objectSchema.name = "Single Page";

                    this.formConfiguration.mySteps.push(newStep);
                    //console.log("Adding Step");

                    this.currentStep = newStep;
                    return true;
                }
            }

            return false;
        }
    }
}